import { styled } from "../stitches.config";

export const StyledSvg = styled("svg", {
  stroke: "inherit",
  fill: "none",
  height: "24px",
  width: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
});

export const StyledStopSvg = styled("stop", {
  stopColor: "$colors$primary_500",
  variants: {
    color: {
      primary: { stopColor: "$colors$primary_50" },
      secondary: { stopColor: "$colors$secondary_50" },
    },
  },
});

export const StyledCircleSvg = styled("circle", {
  fill: "$colors$primary_50",
  variants: {
    color: {
      primary: { stopColor: "$colors$primary_50" },
      secondary: { stopColor: "$colors$secondary_50" },
    },
  },
});
